import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CimSubstationService } from '../../../../../services/cim-substation.service';
import { ToastrService } from 'ngx-toastr';
import { Voltage } from '../../../../../enums/voltage';
import { PermissionsService } from '../../../../../services/permissions.service';
import { NecAddEditModalConnectorSwitchComponent } from '../../../nec-modals/add-edit-modals/nec-add-edit-modal-connector-switch/nec-add-edit-modal-connector-switch.component';

@Component({
  selector: 'lib-nec-substation-details-equipment',
  templateUrl: './nec-substation-details-equipment.component.html',
  styleUrls: ['./nec-substation-details-equipment.component.scss',  '../nec-substation-details.component.scss'],
  standalone: false,
})
export class NecSubstationDetailsEquipmentComponent implements OnInit, OnChanges {
  @Input() substationId: any;
  @Input() substationTemplateInstanceId: any;
  @Input() substationVoltage: any;
  @Input() equipmentName: any;
  @Input() equipmentType: any;
  @Input() selectedEquipment: any;
  @Output() openSchematic = new EventEmitter<void>();
  isOpen = false;
  equipments: any[] = []
  selectedEquipmentId: { value: number | null } | null = { value: 0 };
  modalOpened: boolean = false;
  @ViewChild(NecAddEditModalConnectorSwitchComponent) necAddEditModalSwitchConnectorComponent!: NecAddEditModalConnectorSwitchComponent;


  constructor(private substationService: CimSubstationService,
    private toastr: ToastrService,
    public permissionsService: PermissionsService
  ) {  }

  ngOnInit(): void {
    this.substationVoltage = Voltage[this.substationVoltage as keyof typeof Voltage];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['equipmentType'] && !changes['equipmentType'].firstChange) {
      this.isOpen = false;
      this.selectedEquipmentId = { value: 0 };
      this.modalOpened = false;
      this.equipments = [];
      
      this.getConnectorsBySubstationId(this.substationId);
    }
    
    if (changes['equipmentType']?.firstChange && this.equipmentType) {
      this.getConnectorsBySubstationId(this.substationId);
    }
  }

  getConnectorsBySubstationId(substationId: number): void {
    const dataIn = { id: substationId, equipmentType: this.equipmentType };
    this.substationService.getEquipmentForSubstation(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.equipments = data;
        }
      },
      error: () => {
        this.toastr.error('Error occurred while loading Equipment data');
      }
    });
  }

  selectEquipment(connectorId: number | null){
    this.isOpen = false;
    this.selectedEquipmentId = { value: connectorId };
    this.modalOpened = true;
    this.necAddEditModalSwitchConnectorComponent.resetForm();
  }

  reloadEquipment(){
    this.getConnectorsBySubstationId(this.substationId);
  }

  toggleHiddenInfo(id: number){
    if(this.isOpen === false || this.selectedEquipmentId?.value === id || this.selectedEquipmentId?.value === 0)
      this.isOpen = !this.isOpen;
    this.setEquipmentIdValue(id);
  }

  setEquipmentIdValue(id: number) {
    this.selectedEquipmentId!.value = id;
  }

  newEquipment(){
    this.openSchematic.emit();
  }
}